import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

interface ProtectedRouteProps{
     children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {
  const user = useAuth();
    if (!user) {
        return <Navigate to="/login" replace />;
    }
    return <>{children}</>
}  

export default ProtectedRoute; 